import { Component, Input } from '@angular/core';

@Component({
  selector: 'atlas-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  @Input() size: number;
  @Input() color: string;
  @Input() thickness: number = 3;
}
